/* eslint-disable camelcase */
import React, { useState } from 'react'
import { LilStar } from '../helpers/Star'
import Certificate from './Certificate'

const UserDetails = (profile) => {
  const [certificate, setCertificate] = useState(false)

  const user = profile.profile
  const connectBool = profile.connectBool

  if (user === undefined) {
    return <LilStar />
  }

  let username
  let display_name
  let display_picture

  if (connectBool === true) {
    username = user.username
    display_name = user.display_name
    display_picture = user.display_picture.replace('_normal', '_200x200')
  } else {
    username = user.response.data.user.username
    display_name = user.response.data.user.display_name
    display_picture = user.response.data.user.display_picture
  }

  const extLink = `https://twitter.com/${username}`

  const insetStyle = {
    backgroundImage: `url("${display_picture}")`,
  }

  return (
    <div className="details">
      <div className="icon">
        <div className="icon_inner" style={insetStyle}></div>
      </div>
      <h2>{display_name}</h2>
      <a href={extLink} className="external-link" rel="noreferrer" target="_blank">
        @{username}
      </a>
      {certificate && <Certificate displayName={display_name} certificate={certificate} setCertificate={setCertificate} />}
      {/* <p>{bio}</p> */}
    </div>
  )
}

export default UserDetails
